import {
  Directive,
  Input,
  OnInit,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';
import { FgaService } from './fga.service';

@Directive({
  selector: '[appModuleFga]',
})
export class ModuleFgaDirective implements OnInit {
  @Input('appModuleFga') fgaConfig!: { moduleName: string | string[] };

  constructor(
    private readonly templateRef: TemplateRef<any>,
    private readonly viewContainer: ViewContainerRef,
    private readonly fgaService: FgaService
  ) {}

  ngOnInit(): void {
    this.fgaService.getFgaDetails().subscribe(() => {
      this.updateView();
    });
  }

  private updateView(): void {
    console.info('Update View');
    this.viewContainer.clear();
    if (
      this.fgaService.hasModule(this.fgaConfig.moduleName)
    ) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    }
  }
}
